<template>
     <header id="header" class="w-full fixed z-[9999]">
    <div
      class="w-full fixed h-[155px] top-0 z-[21] pointer-events-none gradient-shadow"
    >
      <div
        class="absolute inset-0 pointer-events-none"
        style="backdrop-filter: blur(0px); -webkit-backdrop-filter: blur(0px)"
      ></div>
      <div
        class="absolute inset-0 pointer-events-none rounded-[inherit]"
        style="
          mask-image: linear-gradient(
            0deg,
            rgba(255, 255, 255, 0) 0%,
            rgba(255, 255, 255, 1) 16.666666666666664%,
            rgba(255, 255, 255, 1) 33.33333333333333%,
            rgba(255, 255, 255, 0) 50%
          );
          -webkit-mask-image: linear-gradient(
            0deg,
            rgba(255, 255, 255, 0) 0%,
            rgba(255, 255, 255, 1) 16.666666666666664%,
            rgba(255, 255, 255, 1) 33.33333333333333%,
            rgba(255, 255, 255, 0) 50%
          );
          backdrop-filter: blur(-7px);
          -webkit-backdrop-filter: blur(-7px);
        "
      ></div>
      <div
        class="absolute inset-0 pointer-events-none rounded-[inherit]"
        style="
          mask-image: linear-gradient(
            0deg,
            rgba(255, 255, 255, 0) 16.666666666666664%,
            rgba(255, 255, 255, 1) 33.33333333333333%,
            rgba(255, 255, 255, 1) 50%,
            rgba(255, 255, 255, 0) 66.66666666666666%
          );
          -webkit-mask-image: linear-gradient(
            0deg,
            rgba(255, 255, 255, 0) 16.666666666666664%,
            rgba(255, 255, 255, 1) 33.33333333333333%,
            rgba(255, 255, 255, 1) 50%,
            rgba(255, 255, 255, 0) 66.66666666666666%
          );
          backdrop-filter: blur(2px);
          -webkit-backdrop-filter: blur(2px);
        "
      ></div>
      <div
        class="absolute inset-0 pointer-events-none rounded-[inherit]"
        style="
          mask-image: linear-gradient(
            0deg,
            rgba(255, 255, 255, 0) 33.33333333333333%,
            rgba(255, 255, 255, 1) 50%,
            rgba(255, 255, 255, 1) 66.66666666666666%,
            rgba(255, 255, 255, 0) 83.33333333333333%
          );
          -webkit-mask-image: linear-gradient(
            0deg,
            rgba(255, 255, 255, 0) 33.33333333333333%,
            rgba(255, 255, 255, 1) 50%,
            rgba(255, 255, 255, 1) 66.66666666666666%,
            rgba(255, 255, 255, 0) 83.33333333333333%
          );
          backdrop-filter: blur(4px);
          -webkit-backdrop-filter: blur(4px);
        "
      ></div>
      <div
        class="absolute inset-0 pointer-events-none rounded-[inherit]"
        style="
          mask-image: linear-gradient(
            0deg,
            rgba(255, 255, 255, 0) 50%,
            rgba(255, 255, 255, 1) 66.66666666666666%,
            rgba(255, 255, 255, 1) 83.33333333333333%,
            rgba(255, 255, 255, 0) 100%
          );
          -webkit-mask-image: linear-gradient(
            0deg,
            rgba(255, 255, 255, 0) 50%,
            rgba(255, 255, 255, 1) 66.66666666666666%,
            rgba(255, 255, 255, 1) 83.33333333333333%,
            rgba(255, 255, 255, 0) 100%
          );
          backdrop-filter: blur(8px);
          -webkit-backdrop-filter: blur(8px);
        "
      ></div>
      <div
        class="absolute inset-0 pointer-events-none rounded-[inherit]"
        style="
          mask-image: linear-gradient(
            0deg,
            rgba(255, 255, 255, 0) 66.66666666666666%,
            rgba(255, 255, 255, 1) 83.33333333333333%,
            rgba(255, 255, 255, 1) 100%,
            rgba(255, 255, 255, 0) 116.66666666666666%
          );
          -webkit-mask-image: linear-gradient(
            0deg,
            rgba(255, 255, 255, 0) 66.66666666666666%,
            rgba(255, 255, 255, 1) 83.33333333333333%,
            rgba(255, 255, 255, 1) 100%,
            rgba(255, 255, 255, 0) 116.66666666666666%
          );
          backdrop-filter: blur(16px);
          -webkit-backdrop-filter: blur(16px);
        "
      ></div>
    </div>
    <nav class="z-[1000] w-full fixed px-5 sm:px-8 pt-1 sm:pt-5 nav-top">
      <div class="flex justify-between">
        <router-link to="/">
          <img
            class="max-h-[68px] w-auto inline-block dark:hidden"
            src="@/assets/images/logo.png"
            alt="logo"
          />
          <img
            class="max-h-[68px] w-auto dark:inline-block hidden"
            src="@/assets/images/logo-white.png"
            alt="logo"
          />
        </router-link>
        <div class="flex items-center">
          <div
            class="menu-open cursor-pointer relative h-[68px] w-[68px] before:content-[''] before:absolute before:top-[28px] before:left-1/2 before:w-9 before:h-0.5 before:bg-black dark:before:bg-white before:-translate-x-1/2 before:transition-all before:duration-300 after:content-[''] after:absolute after:bottom-[28px] after:left-1/2 after:w-9 after:h-0.5 after:bg-black dark:after:bg-white after:-translate-x-1/2 after:transition-all after:duration-300 hover:before:top-[25px] hover:after:bottom-[25px]"
          ></div>
        </div>
      </div>
    </nav>
  </header>
  
</template>

<script>
export default {
  name: 'TopHeader'
}
</script>